import { SVGProps } from 'react';

import { styleConfigs } from '../../resources/styleConfigs';

const PlusIcon = ({
  width = styleConfigs.dimensions.width22,
  height = styleConfigs.dimensions.height22,
  fill = 'currentColor',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8335 9.16658H10.8335V4.16659C10.8335 3.70635 10.4604 3.33325 10.0002 3.33325C9.53993 3.33325 9.16683 3.70635 9.16683 4.16659V9.16658H4.16683C3.70659 9.16658 3.3335 9.53968 3.3335 9.99992C3.3335 10.4602 3.70659 10.8333 4.16683 10.8333H9.16683V15.8333C9.16683 16.2935 9.53993 16.6666 10.0002 16.6666C10.4604 16.6666 10.8335 16.2935 10.8335 15.8333V10.8333H15.8335C16.2937 10.8333 16.6668 10.4602 16.6668 9.99992C16.6668 9.53968 16.2937 9.16658 15.8335 9.16658Z"
      fill={fill}
    />
  </svg>
);

export default PlusIcon;
